import type {UserFiltersType} from '~/utils/types/account/users/types'

export const initUserFilters = (): UserFiltersType => ({
    name: null,
    role: null,
    login: null,
    companyId: null,
    active: true,
})
